import React from 'react';

export type TipoOferta = 'producto' | 'servicio' | 'membresia' | 'listado';

interface TypeSelectorProps {
  value: TipoOferta;
  onChange: (tipo: TipoOferta) => void;
  disabled?: boolean;
}

const TIPOS = [
  { key: 'producto' as const, icon: '📦', label: 'Producto', sub: 'Retail / físico' },
  { key: 'servicio' as const, icon: '🛠', label: 'Servicio', sub: 'Con o sin agenda' },
  { key: 'membresia' as const, icon: '⭐', label: 'Membresía', sub: 'Acceso / recurrente' },
  { key: 'listado' as const, icon: '🏠', label: 'Listado', sub: 'Inmueble / oferta' },
];

export function TypeSelector({ value, onChange, disabled }: TypeSelectorProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-6 pb-6 border-b border-gray-200">
      {TIPOS.map((t) => (
        <button
          key={t.key}
          type="button"
          disabled={disabled}
          onClick={() => onChange(t.key)}
          className={`flex flex-col items-center p-3 rounded-xl border-2 text-center transition-all
            ${
              value === t.key
                ? 'border-blue-500 bg-blue-50'
                : 'border-gray-200 hover:border-gray-300 bg-white'
            } disabled:opacity-50 disabled:cursor-not-allowed`}
        >
          <span className="text-xl mb-1">{t.icon}</span>
          <span className={`text-xs font-medium ${value === t.key ? 'text-blue-700' : 'text-gray-700'}`}>
            {t.label}
          </span>
          <span className="text-[10px] text-gray-400 mt-0.5">{t.sub}</span>
        </button>
      ))}
    </div>
  );
}
